
window.initPaginatedListVideos = function(container = document) {
  const options = {
    root: null,
    rootMargin: "200px",
    threshold: 0
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const vid = entry.target;

        // Swap data-src → src on all <source>
        vid.querySelectorAll("source[data-src]").forEach(srcEl => {
          srcEl.src = srcEl.dataset.src;
          srcEl.removeAttribute("data-src");
        });

        vid.load(); // start buffering
        obs.unobserve(vid); // observe only once
      }
    });
  }, options);

  container.querySelectorAll(".video-wrapper-load video").forEach(v => {
    if (v.querySelector("source[data-src]")) {
      observer.observe(v);
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  window.initPaginatedListVideos();
});
window.addEventListener("scroll", () => {
window.initPaginatedListVideos(document);
});


// document.addEventListener("DOMContentLoaded", function () {
//   const sections = document.querySelectorAll(".image-wrapper-load");
//   const animateDiv = document.querySelector('.media_grid-main');
//   if (!sections.length) return;

//   sections.forEach((section) => {
//     const images = section.querySelectorAll("img[data-src]");

//     if (!images.length) return;

//     const loadImages = () => {
//       images.forEach((img) => {
//         const dataSrc = img.getAttribute("data-src");
//         if (dataSrc) {
//           img.setAttribute("src", dataSrc);
//           img.removeAttribute("data-src");
//         }
//       });
//     };

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             loadImages();
//             obs.unobserve(section);
//           }
//         });
//       },
//       {
//         root: null,
//         // rootMargin: "200px",
//         threshold: 0,
//       }
//     );

//     observer.observe(section);
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const sections = document.querySelectorAll(".image-wrapper-load");
//   if (!sections.length) return;

//   sections.forEach((section) => {
//     const images = section.querySelectorAll("img[data-src]");
//     if (!images.length) return;

//     const loadImages = () => {
//       images.forEach((img) => {
//         const dataSrc = img.getAttribute("data-src");
//         if (dataSrc) {
//           img.setAttribute("src", dataSrc);
//           img.removeAttribute("data-src");
//         }
//       });
//     };

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             loadImages();
//             obs.unobserve(section);
//           }
//         });
//       },
//       {
//         root: null,
//         rootMargin: "200px", // You can increase this if needed
//         threshold: 0,
//       }
//     );

//     // Check if the section is already visible
//     const rect = section.getBoundingClientRect();
//     const windowHeight = window.innerHeight || document.documentElement.clientHeight;

//     if (rect.top < windowHeight && rect.bottom > 0) {
//       // Section is already visible on load → load immediately
//       loadImages();
//     } else {
//       // Otherwise, observe for lazy loading
//       observer.observe(section);
//     }
//   });
// });


// window.initLazyLoadImages = function(container = document) {
//   const sections = container.querySelectorAll(".image-wrapper-load");
//   if (!sections.length) return;

//   sections.forEach((section) => {
//     const images = section.querySelectorAll("img[data-src]");
//     if (!images.length) return;

//     const loadImages = () => {
//       images.forEach((img) => {
//         const dataSrc = img.getAttribute("data-src");
//         if (dataSrc) {
//           img.setAttribute("src", dataSrc);
//           img.removeAttribute("data-src");
//         }
//       });
//     };

//     const observer = new IntersectionObserver(
//       (entries, obs) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             loadImages();
//             obs.unobserve(section);
//           }
//         });
//       },
//       {
//         root: null,
//         rootMargin: "200px",
//         threshold: 0,
//       }
//     );

//     // Check if section is already visible
//     const rect = section.getBoundingClientRect();
//     const windowHeight = window.innerHeight || document.documentElement.clientHeight;

//     if (rect.top < windowHeight && rect.bottom > 0) {
//       loadImages();
//     } else {
//       observer.observe(section);
//     }
//   });
// };

// document.addEventListener("DOMContentLoaded", () => {
//   window.initLazyLoadImages(document);
// });


window.initLazyLoadImages = function(container = document) {
  const sections = container.querySelectorAll(".image-wrapper-load");
  if (!sections.length) return;

  sections.forEach((section) => {
    const images = section.querySelectorAll("img[data-src]");
    if (!images.length) return;

    const loadImages = () => {
      images.forEach((img) => {
        const dataSrc = img.getAttribute("data-src");
        if (dataSrc) {
          img.setAttribute("src", dataSrc);
          img.removeAttribute("data-src");
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadImages();
            obs.unobserve(section);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0,
      }
    );

    // Check if section is already in view
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      loadImages(); // Already visible → load immediately
    } else {
      observer.observe(section); // Observe only if not yet visible
    }
  });
};

// Run on page load
document.addEventListener("DOMContentLoaded", () => {
  window.initLazyLoadImages(document);
});
